// extracted by mini-css-extract-plugin
export var cartIcon = "_oh-0";
export var cartIconContainer = "_oh-1";